import classNames from "classnames";
import { type OrderableTableFooter, type TableColumn } from "components/Tables";
import Table from "components/Tables/Table";
import moment from "moment";
import React from "react";
import { formatShortDate } from "utilities";
import { routes } from "utilities/routing/generatedRoutes";

interface Props {
  payments: server.dto.PaymentsForInvoice
  isOverdue: boolean
  onEdit: (payment: server.dto.Payment) => void
  onDelete: (payment: server.dto.Payment) => void
  canModify: boolean
}

const PaymentsTable = (props: Props) => {
  const { payments, isOverdue, canModify, onEdit, onDelete } = props;

  return <Table
    items={payments.collection}
    isLoading={false}
    onEdit={canModify ? onEdit : undefined}
    onDelete={canModify ? onDelete : undefined}
    getKey={p => p.paymentId.toString()}
    columns={columns}
    footers={getFooter(payments, isOverdue)}
    hideHeader
  />;
};

const columns: Array<TableColumn<server.dto.Payment>> = [{
  key: "paymentDate",
  header: "",
  render: (payment) => <>
    <a href={routes.payment_Detail(payment.paymentId).absolute}>
      {formatShortDate(moment.utc(payment.receivedOn))}
    </a>
    {payment.description && <div className="s1_gray">
      {payment.description}
    </div>}
  </>
}, {
  key: "method",
  header: "",
  render: (product) => product.method.text
}, {
  key: "amount",
  header: "",
  render: (payment) => payment.amount.formatted,
  className: "s1_cell_financialamount"
}];

const getFooter = (payments: server.dto.PaymentsForInvoice, isOverdue: boolean) => {
  const isSettled = payments.outstanding.amount === 0;

  const footer: OrderableTableFooter[] = [{
    key: "settled",
    className: classNames({
      "green-bg white-text": isSettled,
      "gray-250": !isSettled
    }),
    entries: [RESX.Financial.Settled, null, payments.settled.formatted]
  }];

  if (!isSettled) {
    footer.push({
      key: "outstanding",
      className: classNames({
        "red-bg white-text": isOverdue,
        "orange-bg white-text": !isOverdue
      }),
      entries: [RESX.Financial.Outstanding, null, payments.outstanding.formatted]
    });
  }
  return footer;
};

export default PaymentsTable;